// @ts-check
import { LINE_HEIGHT } from 'common/constants/sizes';
import * as ZendeskService from 'common/services/zendesk.service';
import { Flex } from 'components/base/layout-components';
import Text, { Inline } from 'components/base/Text';
import Oops from 'images/characters/oops.svg';
import { getCollaborationProviderName } from './link-account-modal.service';
import _ from 'lodash';
import { LBButton } from '@linearb/buzz';

const LinkAccountErrorHandler = ({ error }) => {
  const Command = (
    <Inline
      size='x-x-large'
      lineHeight={LINE_HEIGHT['medium']}
      weight='600'
      color='shuttleGray'
      align='center'
    >
      {getCollaborationProviderName() === 'Slack' ? '/lb connect' : 'LinkUser'}
    </Inline>
  );

  const status = _.get(error, 'response.status');

  return (
    <Flex
      direction='column'
      items='center'
      content='center'
      height='100%'
      width='100%'
      pt='x-x-large'
    >
      <img src={Oops} alt='Oops' width='40%' />
      <Text
        size='x-xarge'
        lineHeight={LINE_HEIGHT['x-large']}
        weight='300'
        color='shuttleGray'
        align='center'
        pt='3rem'
      >
        {status === 401 ? (
          <Flex
            direction='column'
            items='center'
            content='center'
            height='100%'
            width='100%'
            pt='large'
          >
            <Text
              size='x-x-large'
              lineHeight={LINE_HEIGHT['medium']}
              weight='300'
              color='shuttleGray'
              align='center'
            >
              The link is expired
            </Text>

            <Inline
              size='x-large'
              lineHeight={LINE_HEIGHT['medium']}
              weight='300'
              color='shuttleGray'
              align='center'
              pt='2rem'
            >
              Please send {Command} command in {getCollaborationProviderName()}
            </Inline>
            <Text pt='10rem' color='shuttleGray' size='large'>
              If that doesn't work{' '}
              <LBButton
                variant='ghost'
                onClick={ZendeskService.openSupportRequest}
              >
                contact support
              </LBButton>
            </Text>
          </Flex>
        ) : (
          'Oops, something went wrong, this is probably a temporary issue please try again later...'
        )}
      </Text>
    </Flex>
  );
};

export default LinkAccountErrorHandler;
